/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum];


